export default __webpack_public_path__ + "static/media/ttmik-logo.767db5c6.png";